function get_cookie(name) {
    return document.cookie.split(';').some(c => {
        return c.trim().startsWith(name + '=');
    });
}

function delete_cookie(name, path, domain) {
    if (get_cookie(name)) {
        document.cookie = name + "=" +
            ((path) ? ";path=" + path : "") +
            ((domain) ? ";domain=" + domain : "") +
            ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
    }
}
var logoutBtn = document.getElementById('chMenuItem-logout');

if (logoutBtn) {
    logoutBtn.addEventListener('click', function () {
        delete_cookie('cs_lvp_id', '/', '.lovepop.com');
        delete_cookie('cs_lvp_user', '/', '.lovepop.com');
    });
}